(() => {
  if (document.body.dataset.trustBadgesHidden === 'true') {
    return;
  }

  document.body.dataset.trustBadgesHidden = 'true';

  const SELECTORS = [
    '.trustBarTitle',
    '.badgesContainer',
    '[class*="trustBar"]',
    '[class*="badgesContainer"]',
    '[class*="trust-bar"]',
    '[class*="TrustBar"]',
    '#ultimateTrustBadgeswidgetDiv',
    '.htusb-ui-prod-boost-trust-wrapper',
    '#trust-badge-content-div',
    '[id*="trustBadge"]',
    '[id*="TrustBadge"]',
    '[id*="trust-badge"]',
  ];

  const TEXT_PATTERNS = [
    /^secure\s+(and\s+)?trusted\s+checkout/i,
    /^secure\s+checkout\s+with/i,
    /^secure\s+checkout$/i,
  ];

  const SCOPES =
    '.product-info, .shopify-section--main-product, product-form, .buy-buttons, .product-card, product-card, product-list, .shopify-section--featured-collections, .shopify-section--main-collection, featured-collections-carousel';

  const SCOPED_SELECTORS = ['.frame-content', '.pro_sticky'];

  const hideStyles = {
    display: 'none',
    visibility: 'hidden',
    height: '0',
    maxHeight: '0',
    overflow: 'hidden',
    margin: '0',
    padding: '0',
    opacity: '0',
    pointerEvents: 'none',
  };

  const applyHide = (node) => {
    if (!node || node === document.body || node === document.documentElement) {
      return;
    }

    Object.entries(hideStyles).forEach(([key, value]) => {
      node.style.setProperty(key.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`), value, 'important');
    });

    node.setAttribute('hidden', '');
    node.setAttribute('aria-hidden', 'true');
  };

  const getOwnText = (element) =>
    Array.from(element.childNodes)
      .filter((node) => node.nodeType === Node.TEXT_NODE)
      .map((node) => node.textContent)
      .join('')
      .trim();

  const findWrapper = (node) => {
    let wrapper = node;

    while (wrapper.parentElement) {
      const parent = wrapper.parentElement;

      if (
        parent.classList.contains('product-info') ||
        parent.classList.contains('buy-buttons') ||
        parent.classList.contains('product-card') ||
        parent.tagName === 'PRODUCT-FORM' ||
        parent.tagName === 'PRODUCT-CARD' ||
        parent.tagName === 'FORM'
      ) {
        break;
      }

      if (
        wrapper.matches(
          '.product-info__block-item, .product-card__figure, .product-card__info, shopify-app-block, [id*="shopify-block"], [class*="shopify-app"], [class*="app-block"]'
        )
      ) {
        break;
      }

      wrapper = parent;
    }

    return wrapper;
  };

  const removeTrustWidget = (node) => {
    const wrapper = findWrapper(node);
    applyHide(wrapper);

    if (wrapper.parentElement) {
      wrapper.remove();
    }
  };

  const processRoot = (root) => {
    SELECTORS.forEach((selector) => {
      try {
        root.querySelectorAll(selector).forEach((node) => {
          removeTrustWidget(node);
        });
      } catch (_error) {
        // Ignore invalid selectors in older browsers.
      }
    });

    SCOPED_SELECTORS.forEach((selector) => {
      try {
        root.querySelectorAll(selector).forEach((node) => {
          if (node.closest(SCOPES)) {
            removeTrustWidget(node);
          }
        });
      } catch (_error) {
        // Ignore invalid selectors in older browsers.
      }
    });

    root.querySelectorAll(`${SCOPES} *`).forEach((node) => {
      const ownText = getOwnText(node);

      if (ownText && TEXT_PATTERNS.some((pattern) => pattern.test(ownText))) {
        removeTrustWidget(node);
      }
    });

    root
      .querySelectorAll(
        `${SCOPES} > div, ${SCOPES} .product-info__block-list > *, .product-card__figure > *, product-card .product-card__figure > *`
      )
      .forEach((node) => {
      if (
        node.querySelector(
          '.trustBarTitle, .badgesContainer, [class*="trustBar"], [class*="badgesContainer"], #ultimateTrustBadgeswidgetDiv, .htusb-ui-prod-boost-trust-wrapper'
        )
      ) {
        removeTrustWidget(node);
      }

      const text = node.textContent?.trim() || '';

      if (text.length < 120 && TEXT_PATTERNS.some((pattern) => pattern.test(text))) {
        removeTrustWidget(node);
      }
    });
  };

  const walkShadowRoots = (root) => {
    processRoot(root);

    root.querySelectorAll?.('*').forEach((element) => {
      if (element.shadowRoot) {
        walkShadowRoots(element.shadowRoot);
      }
    });
  };

  let scheduled = false;

  const run = () => {
    scheduled = false;
    walkShadowRoots(document);
  };

  const schedule = () => {
    if (scheduled) {
      return;
    }

    scheduled = true;
    requestAnimationFrame(run);
  };

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  [250, 500, 1000, 2000, 4000, 8000].forEach((delay) => {
    window.setTimeout(run, delay);
  });
})();
